import React, { useEffect, useState } from "react";
import BackBtn from "../../btncomponent/BackBtn";
import ShowImage from "../ShowImage";
import { Link } from "react-router-dom";

import { isAuthenticated } from "../../auth";
import DeleteHome from "./DeleteHome";
import EditDeletebtn from "./EditDeletebtn";

const SingleRoom = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const roomid = props.match.params.ListRooms;
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/home/data/${roomid}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        return setData(data), setLoading(false);
      });
  }, [props]);

  const showloading = () =>
    loading && (
      <div className="d-flex justify-content-center">
        <div className="spinner-border spinner-border-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        <div className="spinner-grow spinner-grow-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );

  return (
    <div className="container mt-5">
      <h2 className="text-muted"> Rooms</h2>
      <br />
      <BackBtn location="/list/rooms" />
      <br />
      {showloading()}
      <div className="row">
        {data.map((room) => {
          return (
            <div className="col-sm-3" key={room._id}>
              <div className="card mb-3">
                <ShowImage item={room} url="home" />
                <div className="card-body">
                  <h5 className="card-title">{room.name}</h5>
                  <p className="card-text">{room.description}</p>
                  <p className="text-muted">
                    <img
                      src="https://img.icons8.com/color/35/000000/key-exchange.png"
                      alt="icon"
                    />{" "}
                    Price: INR {room.price} /Month
                  </p>
                  <p className="text-muted">
                    {" "}
                    <img
                      src="https://img.icons8.com/fluent/25/000000/walking.png"
                      alt="icon"
                    />
                    {room.distance && `${room.distance}`}
                  </p>

                  <EditDeletebtn roomID={room._id} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SingleRoom;
